"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayDataByTranslations = {
    "en": {
        hour: "Hour",
        day: "Day",
        month: "Month",
    },
    "de": {
        hour: "Stunde",
        month: "Monat",
        day: "Tag",
    },
    "nl": {
        hour: "Uur",
        month: "Maand",
        day: "Dag",
    },
    "it": {
        hour: "Ora",
        month: "Mese",
        day: "Giorno",
    },
    "fr": {
        hour: "Heure",
        month: "Mois",
        day: "Jour",
    },
    "es": {
        hour: "Hora",
        month: "Mes",
        day: "Día",
    },
    "ja": {
        hour: "時間",
        month: "月",
        day: "日",
    },
    "en-GB": {
        hour: "Hour",
        month: "Month",
        day: "Day",
    },
    "ru": {
        hour: "Часам",
        day: "Дням",
        month: "Месяцам",
    },
};
